import {queryStringBuilder, ROUTE_STOP_DETAILS} from "../config/paths/apiPaths";
import {saveHistory} from "../indexedDb/historyDb";

export default {
  namespaced: true,

  state: {
    display: false,
    stopDetails: {},
    moreDetails: false,
    loading: false,
  },

  mutations: {
    toggleLoading(state, isLoading) {
      if (isLoading === true) {
        state.loading = true;
      } else if (isLoading === false) {
        state.loading = false;
      } else {
        state.loading = !state.loading;
      }
    },
    hideStopMenu(state) {
      state.display = false;
    },
    showStopMenu(state) {
      console.log('showing stop menu');
      state.display = true
    },

    hideMoreDetails(state) {
      state.moreDetails = false;
    },
    showMoreDetails(state) {
      state.moreDetails = true;
    },

    setStopDetails(state, stopDetails) {
      state.stopDetails = stopDetails;
    }
  },

  actions: {
    openStopMenu({commit}, routeStop) {
      commit('showStopMenu');
      commit('toggleLoading', true);

      return fetch(`${ROUTE_STOP_DETAILS}?${queryStringBuilder(routeStop)}`)
        .then(response => response.json())
        .then(json => {
          commit('toggleLoading', false);
          commit('setStopDetails', json.data);

          saveHistory({
            type: 'route-stop',
            ...json.data,
          });

          return json.data;
        })
        .catch(e => {
          commit('toggleLoading', false);

          console.log('open stop menu error:', e);
        });

    },

    async prepareOpenStopMenu({ commit, rootState, dispatch }, stopItem){
      const {
        routedir, stopseq,
        // company_service_type, company_stopseq, company_routedir,
      } = stopItem;

      const {
        // startc, destinc,
        routeid, routec,
      } = rootState.routeInfo.routeDetails;

      // open stop menu:
      commit('showStopMenu');
      commit('toggleLoading', true);

      try {
        const response = await fetch(`${ROUTE_STOP_DETAILS}?${queryStringBuilder(routeStop)}`);
        const json = await response.json();

        commit('toggleLoading', false);
        commit('setStopDetails', json.data);

        saveHistory({
          type: 'route-stop',
          ...json.data,
        });
      }catch (e) {
        commit('toggleLoading', false);

        console.log('open stop menu error:', e);
      }

      // open only info window
      commit('googleMap/openOnlyInfoWindow', stopItem);
      // update bound
      commit('googleMap/updateBound', [
        {
          ...stopItem,
          ...stopDetails,
          position: {
            lat: stopDetails.lat,
            lng: stopDetails.lng,
          },
        },
      ]);

      // get route line
      dispatch('googleMap/getRouteLine', {
        routeid,
        routedir,
        routec,
        stopseq,
      });
    },
  },

  getters: {},


}
